import {ValidationType} from './ValidationType'

export const AppointmentsValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  StartDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  EndDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  AddedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  UserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  AssignedUserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  SiteID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  Notes: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  AppointmentTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  Confirmed: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ConfirmedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  FollowedUp: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  FollowedUpDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  FollowedUpOwner: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  FollowedUpOwnerDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  FollowUpDueDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  ReminderInterval: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Cancelled: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  CancelledDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  NoShow: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ReminderDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  RecurrenceAppointmentID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  RecurrenceFrequency: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  RecurrenceEndDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  UpdatedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  FeedbackSentDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  SummaryUserAttendees: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 2048,
    maxValue: 0
  },
  SummaryAttendees: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 2048,
    maxValue: 0
  },
  SummaryProperties: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 2048,
    maxValue: 0
  }
};
